var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgUsersCircle = function SvgUsersCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 12.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0ZM21 16a3.124 3.124 0 0 0-1.108-.737A3.762 3.762 0 0 0 18.5 15c-.483 0-.959.09-1.392.263A3.124 3.124 0 0 0 16 16M4 12.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0ZM3 16c.295-.31.674-.562 1.107-.736A3.768 3.768 0 0 1 5.498 15c.483 0 .959.089 1.393.261.433.172.813.423 1.109.733M16 17a4 4 0 1 0-8 0M10 10a2 2 0 1 0 4 0 2 2 0 0 0-4 0Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12a10 10 0 1 0 20 0 10 10 0 0 0-20 0Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgUsersCircle;